import * as Constants from './constants';


const SERVER=Constants.API_URL;
const post= async (uri,payload,onfuckup)=>{
    try{
        const response=await fetch(SERVER+uri,{
            signal:AbortSignal.timeout(7000),
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `${localStorage.token!=undefined ?localStorage.token:''}`
            },
            body:JSON.stringify(payload)
        });
        if(!response.ok){
            
            return {result:false};
            
        }
        const r=await response.json();
        if(r.result==false && r.motive=='notLoggedIn'){
            //logout:
            localStorage.removeItem('token');
            window.location.href='/login';
            return false;
        }else{
           return r;
        }
    }catch(fetchErr){
        console.log('fetcherr:',fetchErr);
        /*app.toast.create({
            //icon:`<i class="f7-icons">exclamationmark_shield_fill</i>`,
            text:'Error de conexión',
            position:'bottom',
            destroyOnClose:true,
            closeTimeout:2000
        }).open();*/
        return {result:false,motive:'Error de conexión'};
    }
}

export  default post;